import React from 'react';
import TreeMap from '../Charts/TreeMap';
import { Card } from 'antd';


const AggTreechart = () => {
  return (
    <Card title="Macro Data">
      <TreeMap />
    </Card>
  )
}

export default AggTreechart